























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IActivity } from "@/types";
import {
  getUserInfo,
  getDistributionActById,
  getDistributionRank,
  getDistributionActSettings,
  getDistributionData
} from "@/api";
import { request } from "@/utils/request";
import MyFooter from "@/components/Footer.vue";
import Rule from "@/components/Rule.vue";
import Leaderboard from "@/components/Leaderboard.vue";
import MyTitle from "@/components/Title.vue";
import MyWxJs, { wx as wechat } from "@/utils/wx.ts";
import { jumpToCourse } from "@/utils/index.ts";

@Component({
  components: {
    MyFooter,
    Rule,
    Leaderboard,
    MyTitle
  }
})
export default class Home extends Vue {
  @Prop({ type: Number, required: true }) distributionId!: number;
  loading = true;
  activity: IActivity = {
    configurationText: {
      banner: {}
    }
  } as IActivity;

  distributeData = {};

  pageConfig = {
    banner: "",
    bannerTitle: "",
    h5Title: "",
    rule: ""
  };

  async created() {
    const config = await MyWxJs.getWxConfig();
    wechat.config(config);
  }

  async mounted() {
    const userInfo = await getUserInfo();
    const config = await getDistributionActById(this.distributionId);
    console.log("config-----------------------", config);
    this.setWechatShare(Object.assign({}, config, { userId: userInfo.userId }));
  }

  get bannerStyle() {
    return {
      backgroundImage: `url("${this.pageConfig.banner}")`
    };
  }
  get invitationBuyCourseUserInfo() {
    return this.activity.invitationBuyCourseUserInfo || {};
  }
  get invitationCardUserInfo() {
    return this.activity.invitationCardUserInfo || {};
  }
  @Watch("distributionId", { immediate: true })
  async getDistributionRank(distributionId: number) {
    this.loading = true;
    try {
      this.distributeData = await getDistributionData(distributionId);
    } catch (error) {
      console.error(error);
    }
    try {
      this.pageConfig = await getDistributionActSettings(distributionId);
    } catch (error) {
      console.error(error);
    }
    if (this.pageConfig.h5Title) {
      document.title = this.pageConfig.h5Title;
      if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
        var i = document.createElement("iframe");
        i.src = "/favicon.ico";
        i.style.display = "none";
        i.onload = function() {
          setTimeout(function() {
            i.remove();
          }, 9);
        };
        document.body.appendChild(i);
      }
    }
    this.$rulePopup({
      value: false,
      rule: this.pageConfig.rule
    });
    this.loading = false;
  }
  toMy() {
    this.$router.push({
      name: "distributionMy",
      params: { distributionId: String(this.distributionId) }
    });
  }
  // 设置微信分享
  setWechatShare(data: any) {
    console.log("data---------", data);
    if (data.shareSettings && data.shareSettings.imgurl) {
      data.shareSettings.imgUrl = data.shareSettings.imgurl;
    }
    let timelineShare = data.shareSettings || {};
    let wxMessageShare = data.shareSettings || {};

    timelineShare = Object.assign(
      {
        title: data.title,
        link: window.location.href,
        imgUrl: "https://app-cdn.btclass.cn/logo-book%202.png"
      },
      timelineShare
    );

    wxMessageShare = Object.assign(
      {
        title: "BT教育",
        desc: data.title,
        link: window.location.href,
        imgUrl: "https://app-cdn.btclass.cn/logo-book%202.png"
      },
      wxMessageShare
    );

    const shareUrl = jumpToCourse({
      courseId: data.courseIds[0],
      distributionId: this.distributionId,
      inviteUserId: data.userId
    });
    timelineShare.link = shareUrl;
    wxMessageShare.link = shareUrl;
    wechat.ready(() => {
      console.log(
        "wechat ready",
        "shareUrl",
        timelineShare.link,
        wxMessageShare.link
      );
      wechat.onMenuShareTimeline(timelineShare);
      wechat.onMenuShareAppMessage(wxMessageShare);
    });
  }
}
